module.exports = __webpack_public_path__ + "static/media/delete.83efa889.svg";